import React from "react";
import { Link } from "react-router-dom";
import "../css/Home.css";
import AutoComplete from "../components/AutoComplete";

function hello() {
  setTimeout(function() {
    const { hash } = window.location;
    if (hash !== "") {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.

      const id = hash.split("#")[2];
      const element = document.getElementById(id);
      let count = element.offsetTop - 100;
      if (element) window.scrollTo({ top: count });
    }
  }, 100);
}

const Home = props => {
  return (
    <div className="homepage">
      <div className="white-box new-banner-wrapper">
        <p>
          <strong>2020 UPDATE</strong>: Now includes damaged asbestos
          information from 2018-19 federal inspections.
        </p>
      </div>

      <div className="white-box">
        <h1>School Checkup</h1>
        <p>Find detailed reports on hazards inside Philadelphia classrooms.</p>
        <br />
        {/* <div>Select a school to see its report:</div> */}

        <div id="inputwrapper">
          <AutoComplete
            getUrl={props.match}
            data={props.data}
            placeholder="Search for a school..."
          />
        </div>
        <div className="flexcontainer searchoptions">
          <div className="flexitem">
            <Link to="/schools#bylocation" onClick={hello}>
              MAP: Search by location
            </Link>{" "}
            <i className="fas fa-angle-right"></i>
          </div>
          <div className="flexitem">
            <Link to="/schools#bytype" onClick={hello}>
              Search by type (Elementary, Middle, High){" "}
            </Link>{" "}
            <i className="fas fa-angle-right"></i>
          </div>
          <div className="flexitem mobileonly">
            <Link to="/about">About the tool </Link>{" "}
            <i className="fas fa-angle-right"></i>
          </div>
        </div>

        <p>
          Many of Philadelphia's 130,000 public-school students spend their
          school days inside buildings that can make them sick and miss school
          and even send them to the hospital. Children are at higher risk from
          school hazards as lead dust, damaged asbestos and asthma triggers such
          as mold, mouse feces and urine, and cockroach parts - all found in far
          too many Philadelphia classrooms.
          <br /> <span className="updatedText">(Updated February 2020)</span>
        </p>
      </div>

      <hr className="linebreak" />
      <img
        src="https://media.inquirer.com/images/RS_1200x800_20180502_TOXICCITY3_A.JPG"
        alt="Students are dismissed for the day at Lewis C. Cassidy School, located at 6523 Lansdowne Ave, in Philadelphia, Tuesday, May 1, 2018."
      />

      <div className="containerPhotoCredit">
        JESSICA GRIFFIN / Staff Photographer
      </div>
      <div className="containerPhotoCaption">
        Students are dismissed for the day at Lewis C. Cassidy School, located
        at 6523 Lansdowne Ave, in Philadelphia, Tuesday, May 1, 2018.
      </div>

      <hr />

      {/* <div className="sidebarsection halfhalf"> */}

      {/* <div className="leftside matchpadding">
                    <h3 className="">
                <span className="outline">Useful external links</span>
                    </h3>

                    <ul className='bulletlist bulletlinks'>
                <li>
                <a href="http://www.philly.com/philly/news/special_packages/toxic-city/stories/How-to-get-your-child-home-tested-for-lead.html">How to get your child or home tested for lead</a>
                </li>
                <li>
                <a href="https://www.epa.gov/lead/learn-about-lead">EPA: a primer on lead</a>
                </li>
                <li>
                <a href="">External link goes here</a>
                </li>
                <li>
                <a href="">External link goes here</a>
                </li>
                    </ul>
            </div> */}
      <div className=" white-box">
        <h3 className="">
          <span className="outline">The hazards</span>
        </h3>
        <p>
          The school finder highlights four areas of concern. Select a topic to
          learn more:
        </p>

        <ul className="bulletlist topicnav">
          <li>
            <Link to="/lead-paint-residue" className="topicSection lead">
              Lead paint residue
            </Link>
          </li>
          <li>
            <Link to="/asbestos" className="topicSection asbestos">
              Damaged asbestos
            </Link>
          </li>
          <li>
            <Link to="/asthma-triggers" className="topicSection asthma">
              Asthma triggers
            </Link>
          </li>
          <li>
            <Link to="/lead-water" className="topicSection water">
              Lead in drinking water
            </Link>
          </li>
        </ul>

        {/* <div className="flexcontainer topicnav">








                </div> */}

        {/* </div> */}
      </div>
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/routes/Home.js